import tw from "tailwind-styled-components";
import ProfileIcon from "../../icons/profileIcon";
import LogoutIcon from "../../icons/logoutIcon";
import { logoutUser } from "../../../../pages/login/functions";
import { useState } from "react";

export interface ProfileMenuProps {
  view: string;
  setView: (value: string) => void;
  showProfileMenu: boolean;
  setShowProfileMenu: (value: boolean) => void;
}

const ProfileMenu = ({
  view,
  setView,
  setShowProfileMenu,
}: ProfileMenuProps) => {

  const [isLoggingOut, setIsLoggingOut] = useState(false);
  
  const myProfile = () => {
    setShowProfileMenu(false);
    setView("/myProfile");
  };

  const logOut = async () => {
    setIsLoggingOut(true);
    setShowProfileMenu(false);
    await logoutUser();
    setIsLoggingOut(false);
  };

  const handleMouseEnter = () => setShowProfileMenu(true);
  const handleMouseLeave = () => setShowProfileMenu(false);

  return (
    <ProfileMenuContainer
      id="burger-menu"
      onMouseEnter={handleMouseEnter}
      onMouseOver={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="py-2" id="myProfile-option">
        <MenuButton
          type="button"
          onClick={myProfile}
          className={view === "/myProfile" ? "bg-[#f5f5f5]" : ""}
        >
          <ProfileIcon />
          {"Mi perfil"}
        </MenuButton>
      </div>
      <div className="py-2 ">
        <MenuButton type="button" onClick={logOut}>
          {isLoggingOut ? 
          <>
            <svg
              className="animate-spin h-4 w-4 text-red-600"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
            <span>Cerrando...</span>
          </> : <>
            <LogoutIcon />
            {"Cerrar sesión"}
          </>}
        </MenuButton>
      </div>
    </ProfileMenuContainer>
  );
};

export default ProfileMenu;

const ProfileMenuContainer = tw.div`
absolute w-44 mt-4 top-16 right-4 z-50 
bg-white divide-y divide-gray-100 
rounded-lg shadow-custom 
`;

const MenuButton = tw.button`
flex w-full items-center 
gap-2 px-4 py-2 hover:bg-[#f5f5f5]
text-gray-800 text-left font-Roboto text-xs font-medium
`;
